import { PROFILES_PATH } from '../../constants'
import getByIdPropReduxSelector from '../../../../redux/selectors/get-by-id-prop'

function getByIdProfileSelector (id) {
  return (state) => {
    return (
      getByIdPropReduxSelector(PROFILES_PATH.DATA)(state, { id })
    )
  }
}

export default getByIdProfileSelector
